import { DetailContent } from "@/features/ui/detail/DetailContent";
import { DetailField } from "@/features/ui/detail/DetailField";
import { DetailHeader } from "@/features/ui/detail/DetailHeader";
import { DetailInformTitle } from "@/features/ui/detail/DetailInformTitle";
import { DetailLabel } from "@/features/ui/detail/DetailLabel";
import { DetailLink } from "@/features/ui/detail/DetailLink";
import { DetailLinkWrapper } from "@/features/ui/detail/DetailLinkWrapper";
import { DetailTitle } from "@/features/ui/detail/DetailTitle";
import DatetimeUtil from "@/utils/dateTimeUtil";
import { Space } from "@mantine/core";
import { useTranslation } from "react-i18next";

const DetailGrade = Object.assign(DetailHeader, {
  Title: DetailTitle,
  Inform: DetailInformTitle,
  Field: DetailField,
  Label: DetailLabel,
  Link: DetailLink,
  LinkWrapper: DetailLinkWrapper,
  Content: DetailContent,
});

interface GradeDetailHeaderProps {
  data: any;
}

export const GradeDetailHeader = (params: GradeDetailHeaderProps) => {
  const { data } = params;
  const { t } = useTranslation();
  const grade = data?.data?.rows[0];

  return (
    <DetailGrade>
      <DetailGrade.Title>[{t("common.detail", { item: t("item.grade") })}]</DetailGrade.Title>
      <Space h={8} />
      <DetailGrade.Field>
        <DetailGrade.Label>{t("item.gradeCode")}</DetailGrade.Label>
        <DetailGrade.Content>{grade?.code}</DetailGrade.Content>
      </DetailGrade.Field>
      <DetailGrade.Field>
        <DetailGrade.Label>{t("item.gradeName")}</DetailGrade.Label>
        <DetailGrade.Content>{grade?.name}</DetailGrade.Content>
      </DetailGrade.Field>
      <DetailGrade.Field>
        <DetailGrade.Label>
          {t("info.creatorUserCode")} ({t("info.createdAt")})
        </DetailGrade.Label>
        <DetailGrade.Content>
          {grade?.creatorUserCode} ({grade?.createdAt ? DatetimeUtil(grade?.createdAt) : ""})
        </DetailGrade.Content>
      </DetailGrade.Field>
    </DetailGrade>
  );
};
